/* ==========================================================================
   SelectPanel > Client > Store > Actions
   ========================================================================== */

/* Types */
const DESTROY = 'SELECT_PANEL::DESTROY';
const DISPLAY = 'SELECT_PANEL::DISPLAY';
const HIDE = 'SELECT_PANEL::HIDE';

const ENABLE = 'SELECT_PANEL::ENABLE';
const DISABLE = 'SELECT_PANEL::DISABLE';
const TOGGLE_LOADING = 'SELECT_PANEL::TOGGLE_LOADING';
const RESET = 'SELECT_PANEL::RESET';
const SET_ERROR = 'SELECT_PANEL::SET_ERROR';
const RESET_STATUS = 'SELECT_PANEL::RESET_STATUS';
const SET_VALUE = 'SELECT_PANEL::SET_VALUE';
const SET_OPTIONS = 'SELECT_PANEL::SET_OPTIONS';
const CHANGE_OPTIONS = 'SELECT_PANEL::CHANGE_OPTIONS';
const CHANGE_VALUE = 'SELECT_PANEL::CHANGE_VALUE';

const OPEN_PANEL = 'SELECT_PANEL::OPEN_PANEL';
const CLOSE_PANEL = 'SELECT_PANEL::CLOSE_PANEL';

/* Actions */
const display = () => ({ type: DISPLAY });
const hide = () => ({ type: HIDE });
const enable = () => ({ type: ENABLE });
const disable = () => ({ type: DISABLE });
const toggleLoading = () => ({ type: TOGGLE_LOADING });
const reset = payload => ({ type: RESET, payload });
const setError = () => ({ type: SET_ERROR });
const resetStatus = () => ({ type: RESET_STATUS });
const setValue = payload => ({ type: SET_VALUE, payload });
const setOptions = payload => ({ type: SET_OPTIONS, payload });
const changeOptions = payload => ({ type: CHANGE_OPTIONS, payload });

const changeValue = payload => ({ type: CHANGE_VALUE, payload });

const openPanel = payload => ({ type: OPEN_PANEL, payload });
const closePanel = () => ({ type: CLOSE_PANEL });

const destroy = () => ({ type: DESTROY });

/* Exports */
module.exports = {
    types: {
        DISPLAY,
        HIDE,
        ENABLE,
        DISABLE,
        TOGGLE_LOADING,
        SET_ERROR,
        RESET_STATUS,
        SET_VALUE,
        SET_OPTIONS,
        CHANGE_OPTIONS,
        CHANGE_VALUE,
        RESET,
        OPEN_PANEL,
        CLOSE_PANEL,
        DESTROY
    },
    actions: {
        display,
        hide,
        enable,
        disable,
        toggleLoading,
        setError,
        resetStatus,
        setValue,
        setOptions,
        changeOptions,
        changeValue,
        reset,
        openPanel,
        closePanel,
        destroy
    }
};
